<template>
    <div class="history-detail">
        <Loading v-if="isLoading"></Loading>

        <template v-else-if="historyData.length === 0">
            <div class="row empty-data">
                <h3 class="text-center mt-3">
                    {{ getTranslatedText(`no data`) }}
                </h3>
            </div>
        </template>
        <template v-else>
            <HistoryTable :history-data="historyData" />
            <Pagination v-if="totalPages > 1 && historyData.length > 0" :current-page="currentPage"
                :total-pages="totalPages" @change-page="handlePageChange" />
        </template>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import utilMixins from "@/mixins/utils/utils-mixins";
import Loading from "@/components/common/loading.vue";
import HistoryTable from "./HistoryTable.vue";
import Pagination from "@/components/common/Pagination.vue";

export default {
    name: 'HistoryDetail',
    components: { Loading, HistoryTable, Pagination },
    mixins: [languageMixins, utilMixins],
    props: {
        transactionId: {
            type: String,
            default: null
        },
        historyData: {
            type: Array,
            required: true
        },

        isLoading: {
            type: Boolean,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    methods: {
        handlePageChange(page) {
            this.$emit('change-page', page);
        }
    }
}
</script>

<style lang="scss">
@import "@/public/scss/history.scss";
</style>